import { invariant } from '@streem/toolbox';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { ObservableMap } from '../../../util/observable_map';
import { findInGroup, mapWallItemFromWallItemEvents } from '../../wall/utils';
import { DefaultConnectedStrategy, NameConnectedStrategy, } from '../video_controller/connected_strategy';
import { VideoController } from '../video_controller/video_controllers';
export class VideoState extends ObservableMap {
    constructor(config) {
        super();
        this.config = config;
        this.localController = this.values.pipe(map((cs) => cs.find((c) => c.ownerIsLocalUser)));
    }
    removeVideoController(controller) {
        controller.destroy();
    }
    createNewController(args) {
        invariant(this.config.context.callSettings, 'Expected callSettings to be defined when creating a new controller');
        invariant(this.config.context.localUserId, 'Expected localUserId to be defined when creating a new controller');
        if (!this.has(args.wallItemId)) {
            const isLocalUser = args.ownerUserId.compare(this.config.context.localUserId);
            const track = this.findVideoTrack(isLocalUser);
            const wallItem = this.findWallItem(args.wallItemId);
            const controller = new VideoController({
                id: args.wallItemId,
                roomWall: this.config.roomWall,
                roomId: this.config.context.roomId,
                track,
                wallItem,
                owner: {
                    id: args.ownerUserId,
                    isLocalUser,
                },
                onDestroy: (controller) => void this.delete(controller.id),
            });
            /**
             * If the VideoTrack WallItem does not have a `name`, then we
             * are Streeming with an old iOS / Android App. This app
             * will not support 2WV.
             */
            if (!args.videoTrackName || !this.config.trackProvider.useNamedVideoTracks) {
                controller.setConnectedStrategy(new DefaultConnectedStrategy(track));
            }
            else {
                controller.setConnectedStrategy(new NameConnectedStrategy(wallItem, track));
            }
            controller.connect();
            this.set(args.wallItemId, controller);
        }
    }
    clearState() {
        this.forEach(this.removeVideoController);
    }
    findVideoTrack(isLocalUser) {
        return (isLocalUser
            ? this.config.trackProvider.localVideoTrack
            : this.config.trackProvider.remoteVideoTrack).pipe(distinctUntilChanged(), shareReplay(1));
    }
    findWallItem(id) {
        return this.config.roomWall.itemsById.pipe(findInGroup(id), mapWallItemFromWallItemEvents('videoTrack'));
    }
}
//# sourceMappingURL=video_state.js.map